<template>
  <div id="lookcreator">
    <!-- Usamos el mismo del filtro de los tienda de tickets apracados -->
    <v-toolbar class="sub-toolbar" flat>
    <Menu>
        <template v-slot:tickets-aparcados>&nbsp;</template>
        <template v-slot:carrito>&nbsp;</template>
    </Menu>
    </v-toolbar>
    <div>  
        <div class="w-100 pt-5">
          <ProductsList :tienda="false"></ProductsList>
        </div>
    </div>
    <div >
      <div>
        <v-text-field v-model="titulo" placeholder="Introduce un titulo..."/>
      </div>
      <div id="canvas-container" style="width: 650px; height:650px" ref="dropzone" class="boardRight" @drop.prevent="handleDrop"  @dragover.prevent="handleDragOver">
        <canvas id="canvas" ref="can"></canvas>
        <v-textarea v-model="descripcion" rows="2" placeholder="Introduce una descripción..."/>
        <div class="d-inline-block">
          <a class="unishop-button-secondary unishop-keep-shopping" @click="borrar()">Borrar</a>
        </div>
        <div class="float-right">
          <a class="unishop-button-secondary unishop-keep-shopping" @click="guardarLook()">Guardar</a>
          <a class="unishop-button" @click="reiniciarLook()">Reiniciar</a>
        </div>
      </div>
    </div>
    <div class="mt-10">
      <section>
        <ul id="services">
          <li>
            <div class="facebook">
              <a href="javascript:void(0);">
                <i class="icon-facebook2" aria-hidden="true"></i>
              </a>
            </div>
            <span>Facebook</span>
          </li>
          <li>
            <div class="twitter">
              <a href="javascript:void(0);">
                <i class="icon-twitter2" aria-hidden="true"></i>
              </a>
            </div>
            <span>Twitter</span>
          </li>
          <li>
            <div class="linkedin">
              <a href="javascript:void(0);">
                <i class="icon-linkedin" aria-hidden="true"></i>
              </a>
            </div>
            <span>LinkedIn</span>
          </li>
          <li>
            <div class="instagram">
              <a href="javascript:void(0);">
                <i class="icon-instagram" aria-hidden="true"></i>
              </a>
            </div>
            <span>Instagram</span>
          </li>
          <li>
            <div class="instagram">
              <a href="javascript:void(0);">
                <i class="icon-pinterest2" aria-hidden="true"></i>
              </a>
            </div>
            <span>Instagram</span>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import { fabric } from 'fabric';
import Menu from '@/views/tienda/components/menu/Menu.vue';
import ProductsList from '@/views/tienda/components/products_list/ProductsListContainer';

import { LookApiService } from '@/api/LookApiService'
import { Util } from '@/api/Util'

const lookApiService = new LookApiService()
const util = new Util()

export default {
  name: "LookCreator",
  props: ['lookid'],
  data() {
    return {
      canvas : '',
      elementosDropped : [],
      titulo: '',
      descripcion: '',
      idLook: null,
      user: this.$store.getters.getUserName
    }
  },
  components : {
    Menu,
    ProductsList
  },
  mounted() {
    /** */
    this.$root.$on('addToCanvas', (event) => {
        this.handleTouchDrop(event)
    });
    /** */
    const ref = this.$refs.can;
    this.canvas = new fabric.Canvas(ref,{ stateful: true})
    this.canvas.on('object:moving', this.moveHandler)
    //funcion que mueve el objeto a la posicion original
    this.canvas.on('object:modified', this.preventBound)
    this.canvas.preserveObjectStacking = true
    this.canvas.setHeight(document.getElementById('canvas-container').offsetHeight-10)
    this.canvas.setWidth(document.getElementById('canvas-container').offsetWidth-10)
    this.canvas.backgroundColor="white"
    this.canvas.renderAll()
    this.idLook = this.lookid
    if (typeof(this.idLook) != 'undefined' && this.idLook != null) {
      this.getLook()
    }
  },
  created () {
    this.cambioTitulo()
    this.$store.commit('showCarritoModal', false)
    this.$store.commit('showTickets', false)
    this.$store.commit('showFiltro', false)
    this.$store.commit('showFiltroTickets', false)
    this.$store.commit('showBusqueda', false)
  },
  methods: {
    cambioTitulo () {
      this.$store.state.tituloIcono = `<i class="icon-scissors"></i>`
      this.$store.state.titulo = "Look creator"
    },
    handleDragStart(e) {
      var images = document.querySelectorAll('#images img');
      [].forEach.call(images, function (img) {
          img.classList.remove('img_dragging');
      });
      e.currentTarget.classList.add('img_dragging');
    },

    handleDragOver(e) {
      if (e.preventDefault) {
          e.preventDefault(); // Necessary. Allows us to drop.
      }

      e.dataTransfer.dropEffect = 'copy'; // See the section on the DataTransfer object.
      // NOTE: comment above refers to the article (see top) -natchiketa

      return false;
    },

    handleDragEnter(e) {
          // this / e.target is the current hover target.
          this.classList.add('over');
    },

    handleDragLeave(e) {
        this.classList.remove('over'); // this / e.target is previous target element.
    },

    handleDrop(e) {
    // this / e.target is current target element.

      if (e.stopPropagation) {
          e.stopPropagation(); // stops the browser from redirecting.
      }

      var img = document.querySelector('#images img.img_dragging');

      //console.log('event: ', e);
      let scale = 50 / img.width;
      var newImage = new fabric.Image(img, {
          // width: img.width,
          // height: img.height,
          scaleX: scale,
          scaleY: scale,
          // Set the center of the new object based on the event coordinates relative
          // to the canvas container.
          left: e.layerX,
          top: e.layerY,
          id: img.id,
          // crossOrigin: 'anonymous'
      });
      this.canvas.add(newImage);
      this.canvas.renderAll();
      var encontrado = -1;
      var idimg = img.id
      for( var i = 0, len = this.elementosDropped.length; i < len; i++ ) {
          if( this.elementosDropped[i] === idimg) {
              encontrado = i;
              break;
          }
      }
      if (encontrado === -1) {
          this.elementosDropped.push(idimg);  
          console.log(this.elementosDropped);
      }
      // return false;
    },
    handleTouchDrop(e) {
      if (e.stopPropagation) {
          e.stopPropagation(); // stops the browser from redirecting.
      }

      var img = e

      //console.log('event: ', e);
      let scale = 100 / img.width;
      var newImage = new fabric.Image(img, {
          // width: img.width,
          // height: img.height,
          scaleX: scale,
          scaleY: scale,
          // Set the center of the new object based on the event coordinates relative
          // to the canvas container.
          left: 10,
          top: 10,
          id: img.id,
          // crossOrigin: 'anonymous'
      });
      this.canvas.add(newImage);
      this.canvas.renderAll();
      var encontrado = -1;
      var idimg = img.id
      for( var i = 0, len = this.elementosDropped.length; i < len; i++ ) {
          if( this.elementosDropped[i] === idimg) {
              encontrado = i;
              break;
          }
      }
      if (encontrado === -1) {
          this.elementosDropped.push(idimg);  
      }
    },
    handleDragEnd(e) {
    // this/e.target is the source node.
      var images = document.querySelectorAll('#images img');
      [].forEach.call(images, function (img) {
          img.classList.remove('img_dragging');
      });
    },
    borrar() {
      this.canvas.remove(this.canvas.getActiveObject());
      this.canvas.renderAll()   
    },
    getLook() {
      lookApiService.getLookById(this.idLook)
        .then(data => {
          console.log(data)
          this.titulo = data.mslTitulo
          this.descripcion = data.mslDesc
          for (var i=0; i<data.lookArticulos.length; i++) {
          
            let url = this.getFoto(data.lookArticulos[i].articulo)
            var that = this
            let dataAux = data.lookArticulos[i]
            fabric.Image.fromURL(url, (image) => {
                image.set({
                  // width: data.lookArticulos[i].mslaAncho,
                  // height: data.lookArticulos[i].mslaAlto,
                  angle: dataAux.mslaRotacion,
                  scaleX: dataAux.mslaAncho / image.width,
                  scaleY: dataAux.mslaAlto / image.width,
                  left: dataAux.mslaCordX,
                  top: dataAux.mslaCordY,
                  id: dataAux.articulo.id,
                  mslaId: dataAux.mslaId,
                  mslaUid: dataAux.mslaUid,
                });
                that.canvas.add(image);
                that.canvas.renderAll();
            });
          }
        })
    },
    getFoto(productAux) {
      let url = ''
      if (productAux.fotos) {
        for (var i = 0; i < productAux.fotos.length; i++) {
          if (productAux.fotos[i].porDefecto === "S") {
            if (productAux.fotos[i].url) {
              url=productAux.fotos[i].url
            }
          } else {
            if (productAux.fotos[i].url) {
              if (url === '') {
                url =  productAux.fotos[i].url
              }
            }
          }
        }
      } 
      if (url === '') {
        return require('@/assets/images/noimg.jpg')
      } else {
        return url
      }
    },
    guardarLook(){
      if (this.canvas.getObjects.length > 0) {
        //console.log(this.canvas.getObjects())
        var url = this.canvas.toDataURL("image/png");
        // url = url.replace('data:image/png;base64,','')
        // console.log(url)
        // var w=window.open('about:blank','image from canvas');
        // w.document.write("<img src='"+url+"' alt='from canvas'/>");
        
        var look = {
          mslTitulo : this.titulo,
          mslDesc : this.descripcion,
          mslUsuCre: this.user.substring(0,50)
          // msl_imagen : this.base64ToArrayBuffer(url)
        }
        let lookArticulosAux= {
						lookArticulos : []
				}
        for (var i = 0; i < this.canvas.getObjects().length; i++) {
					let lookArticuloAux= {
							mslaCordX : Math.round(this.canvas.getObjects()[i].left),
							mslaCordY : Math.round(this.canvas.getObjects()[i].top),
							mslaAlto: Math.round(this.canvas.getObjects()[i].height * this.canvas.getObjects()[i].scaleY),
							mslaAncho: Math.round(this.canvas.getObjects()[i].width * this.canvas.getObjects()[i].scaleX),
              mslaIdArtic: this.canvas.getObjects()[i].id,
              mslaId: this.canvas.getObjects()[i].mslaId,
              mslaUid: this.canvas.getObjects()[i].mslaUid,
							mslaRotacion: Math.round(this.canvas.getObjects()[i].angle)
						}
					lookArticulosAux.lookArticulos.push(lookArticuloAux)
        }
        Object.assign(look, lookArticulosAux)
        var canvasAux = this.canvas.toCanvasElement()
        if (typeof(this.idLook) != 'undefined' && this.idLook != null) {
          let mslId = {
            mslId : this.idLook
          }
          Object.assign(look, mslId)
          lookApiService.updateLook(look)
            .then(data => {
              canvasAux.toBlob((blob) => {
                let file = new File([blob], "fileName.jpg", { type: "image/jpeg" })
                lookApiService.updateLookImagen(file, data.data.mslId)
                  .then(data => {
                    alert('Look modificado correctamente')
                })
                .catch(error => {
                  util.mostrarEnConsola('lookApiService - updateLookImagen', error, 'ERROR')
                })
              }, 'image/jpeg',data, this);
            })
            .catch(error => {
              util.mostrarEnConsola('lookApiService - updateLook', error, 'ERROR')
            })
        } else {
          lookApiService.addLook(look)
            .then(data => {
              canvasAux.toBlob((blob) => {
                let file = new File([blob], "fileName.jpg", { type: "image/jpeg" })
                lookApiService.updateLookImagen(file, data.mslId)
                  .then(data => {
                    alert('Look creado correctamente')
                    this.reiniciarLook()
                  })
                  .catch(error => {
                    util.mostrarEnConsola('lookApiService - updateLookImagen', error, 'ERROR')
                  })
              }, 'image/jpeg',data, this);

              // alert('Look creado correctamente')
              // console.log(data)
              // this.reiniciarLook()
            })
            .catch(error => {
              util.mostrarEnConsola('lookApiService - addLook', error, 'ERROR')
            })
        }
        
      }
    },
    reiniciarLook() {
      // reiniciamos la dropzone
      this.titulo = ''
      this.descripcion = ''
      this.idLook = null
      this.elementosDropped = []
      var imagenes =  this.canvas.getObjects()
      imagenes.forEach(element => this.canvas.remove(element))
    },
    // Al mover un elemento en el canvas lo traemos al frente
     moveHandler: (function (e) {
        var movingObject = e.target;
        this.canvas.bringToFront(movingObject)
        //console.log(movingObject.get('left'), movingObject.get('top'));
    }),
    //evitamos que los elementos se puedan ir del canvas aunque dejamos una pequeño margen de 50 px
    preventBound: (function (e){
        var obj = e.target;
        if (obj.left < 0 - 200
        || obj.top < 0 - 200
        || obj.left + (obj.width * obj.scaleX) > obj.canvas.width + 200
        || obj.top + (obj.height * obj.scaleY) > obj.canvas.height + 200) {
            obj.top = obj._stateProperties.top
            obj.left = obj._stateProperties.left
            obj.scaleX = obj._stateProperties.scaleX
            obj.scaleY = obj._stateProperties.scaleY
            obj.setCoords()
          }
    })
  }
};

</script>
<style>
section #services {
  text-align: center;
  transform: translatez(0);

    margin-top: 140px;
}
section #services h2 {
  margin: 80px 0px 40px;
  color: #fff;
  font-size: 2.4em;
  text-transform: uppercase;
  text-align: center;
}
section #services li {
  width: 120px;
  height: 140px;
  display: inline-block;
  margin: 20px;
  list-style: none;
}
section #services li div {
  width: 101px;
  height: 101px;
  color: #00639f;
  font-size: 2.9em;
  text-align: center;
  line-height: 93px;
  background-color: #00639f;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
section #services li a {
  color: #ffffff;
}
section #services li i {
  font-size: 1em;
}

section #services li div:hover {
  transform: rotate(360deg);
  border-radius: 100px;
}
section #services li span {
  width: 120px;
  height: 31px;
  display: block;
  padding: 15px 0px;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.2em;
  text-align: center;
}
.credits a {
  display: block;
  text-align: center;
  color: #74d4b3;
  text-decoration: none;
  font-size: 24px;
  margin-top: 50px;
  background: white;
  padding: 20px;
  max-width: 300px;
}
</style>
